import { FC } from 'react';
import { WarningIcon } from 'assets/icons';
import { CustomButton } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';

interface PayAdjustmentBannerProps {
  suggestionsCount: number;
  onReviewClick: () => void;
  isLoading?: boolean;
}

const PayAdjustmentBanner: FC<PayAdjustmentBannerProps> = ({ onReviewClick, suggestionsCount, isLoading }) => {
  return (
    <div className="flex items-center justify-between rounded-lg border border-borderGray bg-[#EFF6FF] p-4">
      <div className="flex items-center gap-5">
        <div className="rounded-full bg-white p-3">
          <WarningIcon className="path path-stroke-current h-[22px] w-[22px] text-tertiaryText" />
        </div>
        <div className="flex w-[80%] flex-col gap-1">
          <h3 className="text-lg font-semibold text-primaryText">Possible pay adjustments found</h3>
          <p className="text-accentText">
            We found some possible transactions for pay adjustments. You can add or discard suggestions.
          </p>
        </div>
      </div>
      <CustomButton id="review-suggestions" onClick={onReviewClick} type={ButtonType.PRIMARY}>
        Review {suggestionsCount} {suggestionsCount === 1 ? 'suggestion' : 'suggestions'}
      </CustomButton>
    </div>
  );
};

export default PayAdjustmentBanner;
